import script from "./PayOrgInvoiceButton.vue?vue&type=script&lang=js"
export * from "./PayOrgInvoiceButton.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__